import { PolicySeverity } from "@repo/api/schemas/policies.schema";
import { capitalizeFirstLetter } from "@repo/mfe-core";
import { Typography } from "@saviynt/design-system";
import { FormattedMessage } from "react-intl";
import { usePoliciesForm } from "../PoliciesFormContext";

const severityBgMap: Record<
  PolicySeverity,
  { bg: string; text: string; border: string }
> = {
  low: {
    bg: "--color-background-success-subtle",
    text: "--color-foreground-success-medium",
    border: "--color-border-success-subtle",
  },
  critical: {
    bg: "--color-background-critical-subtle",
    text: "--color-foreground-critical-bold",
    border: "--color-border-critical-subtle",
  },
  high: {
    bg: "--color-background-orange-subtle",
    text: "--color-foreground-orange-medium",
    border: "--color-border-orange-subtle",
  },
  medium: {
    bg: "--color-background-warning-subtle",
    text: "--color-foreground-warning-medium",
    border: "--color-border-warning-subtle",
  },
};

export default function PoliciesSeverity() {
  const { severity, setSeverity } = usePoliciesForm();

  return (
    <div>
      <Typography kind="label" desktop="h3-d" mobile="h3-d">
        <FormattedMessage
          defaultMessage="Severity"
          id="p08YcN"
          description="Label for severity selection"
        />
      </Typography>

      <div className="Policies-Severity-Section grid grid-cols-4 border p-1">
        {(["critical", "high", "medium", "low"] as PolicySeverity[]).map(
          (s) => (
            <button
              key={s}
              onClick={() => setSeverity(s)}
              className="py-2 text-sm font-medium transition-colors rounded"
              style={
                severity === s
                  ? {
                      backgroundColor: `var(${severityBgMap[s].bg})`,
                      color: `var(${severityBgMap[s].text})`,
                      border: `1px solid var(${severityBgMap[s].border})`,
                    }
                  : { color: "var(--color-foreground-secondary-bold, #00245b)" }
              }
            >
              {capitalizeFirstLetter(s)}
            </button>
          ),
        )}
      </div>
    </div>
  );
}
